import type { ObservationBreadcrumbProps } from "./observation-breadcrumb.type";

import AncestorsBreadcrumb from "@/modules/ancestors/ancestors-breadcrumb";

import { getObservationBreadcrumbItems } from "./observation-breadcrumb.helper";

const ObservationBreadcrumb = ({
  observation,
  ...options
}: ObservationBreadcrumbProps) => {
  const ancestors = getObservationBreadcrumbItems(observation);

  return <AncestorsBreadcrumb {...options} ancestors={ancestors} />;
};

export default ObservationBreadcrumb;
